import { showError } from '@utils';
import { useEffect } from 'react';

export const useBookingErrors = ({
  errorMessage,
  ordersResponse,
  taskResponse,
  userResponse,
  commentsResponse,
  changelogResponse,
  smsResponse,
  bookingHistoryQueryInfiniteQuery,
}) => {
  useEffect(() => {
    const errors = [
      errorMessage,
      ordersResponse?.error,
      taskResponse?.error,
      userResponse?.error,
      commentsResponse?.error,
      changelogResponse?.error,
      smsResponse?.error,
      bookingHistoryQueryInfiniteQuery?.error,
    ].filter(Boolean);

    errors.forEach(showError);
  }, [
    errorMessage,
    ordersResponse?.error,
    taskResponse?.error,
    userResponse?.error,
    commentsResponse?.error,
    changelogResponse?.error,
    smsResponse?.error,
    bookingHistoryQueryInfiniteQuery?.error,
  ]);
};
